/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path apicaller
 * @description Constants for the API
 */
export const SERVER_ADDR_COOKIE_NAME = "qprbp-server-addr";
export const SESSION_TOKEN = "session-token";
export const XSRF_COOKIE_NAME = "xsrf-token";
export const XSRF_HEADER_NAME = "x-xsrf-token";
// eslint-disable-next-line no-shadow
export enum ApiEndpoint {
  childelements = "childelements",
  authenticate = "authenticate",
  meaquery = "meaquery",
  profiles = "profiles",
  logout = "logout",
  sessionstatus = "sessionstatus",
  landingpage = "landingpage",
  tenants = "tenants",
  config = "config",
}
